var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "120px",
    viewBox: "0 0 160 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48A69B91-3776-4E8F-8F76-3A0C73D23CEE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.0%",
    y: "-3.8%",
    width: "106.0%",
    height: "107.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.685622063   0 0 0 0 0.685622063   0 0 0 0 0.685622063  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1_Fogot-Password_10",
    transform: "translate(-881.000000, -360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(693.000000, 281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contain",
    filter: "url(#filter-1)",
    fill: "#F6F7FA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 535,
    height: 419,
    rx: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L534,0 L534,0 L534,419 L10,419 C4.4771525,419 6.76353751e-16,414.522847 0,409 L0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z",
    id: "Background",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_success",
    transform: "translate(188.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    cx: 78.489239,
    cy: 85.6826087,
    r: 34.1478261
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3153259,71.2826087 C95.7457607,71.6347826 89.3674998,80.2173913 81.0718477,90.4434783 L76.0370651,96.5217391 L75.3457607,97.3565217 L74.6153259,96.5869565 C68.0935868,89.9086957 63.6979346,84.9521739 64.0109781,84.6391304 C64.3240216,84.326087 69.2935868,88.7478261 75.9718477,95.2304348 L74.5501085,95.3086957 L79.4805433,89.126087 C87.789239,78.926087 94.8718477,70.9304348 95.3153259,71.2826087 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.997935,71.9347826 C125.993587,68.3478261 121.324022,68.6869565 121.324022,68.6869565 L121.454456,71.1913043 C124.154456,70.7217391 125.824022,73.8782609 125.824022,73.8782609 L126.997935,71.9347826 Z",
    id: "Path",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.089239,79.4478261 C27.0848911,75.8608696 22.4153259,76.2130435 22.4153259,76.2130435 L22.5457607,78.7043478 C25.2457607,78.2478261 26.9153259,81.4043478 26.9153259,81.4043478 L28.089239,79.4478261 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5718477,29.8304348 C87.9848911,31.473913 91.3501085,25.2391304 91.3501085,25.2391304 L88.0501085,23.3608696 C86.4457607,27.1826087 81.0457607,26.7391304 81.0457607,26.7391304 L82.5718477,29.8304348 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5588042,36.5217391 C50.0414129,36.7826087 49.7414129,39.9521739 49.7414129,39.9521739 L51.4240216,40.1478261 C51.4240216,38.2956522 53.7327172,37.5391304 53.7327172,37.5391304 L52.5588042,36.5217391 Z",
    id: "Path",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.332717,59.6478261 C159.697935,57.1434783 156.724022,56.073913 156.724022,56.073913 L156.110978,57.6521739 C157.910978,58.1086957 158.0675,60.5347826 158.0675,60.5347826 L159.332717,59.6478261 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2457607,3.57391304 C67.6370651,1.06956522 64.6240216,1.86073379e-13 64.6240216,1.86073379e-13 L64.0109781,1.57826087 C65.8109781,2.03478261 65.9805433,4.46086957 65.9805433,4.46086957 L67.2457607,3.57391304 Z",
    id: "Path",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.028369404,44.9826087 C-0.428152335,48.8956522 4.77619549,49.8608696 4.77619549,49.8608696 L5.71532593,47.2521739 C2.59793462,46.9652174 2.14141288,43.3391304 2.14141288,43.3391304 L0.028369404,44.9826087 Z",
    id: "Path",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.828369,29.7521739 C123.358804,29.8956522 124.1675,26.8173913 124.1675,26.8173913 L122.537065,26.3478261 C122.237065,28.1869565 119.810978,28.5652174 119.810978,28.5652174 L120.828369,29.7521739 Z",
    id: "Path",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.641413,40.0565217 C133.963187,40.2467119 133.256214,40.3129906 132.554456,40.2521739 C131.852694,40.3144398 131.14546,40.2481366 130.4675,40.0565217 C131.844891,39.7782609 133.264022,39.7782609 134.641413,40.0565217 L134.641413,40.0565217 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.845761,34.3695652 C137.052516,35.0580267 137.123397,35.7801286 137.054456,36.4956522 C137.122691,37.2068692 137.051807,37.924568 136.845761,38.6086957 C136.655515,37.921567 136.589262,37.2060302 136.650109,36.4956522 C136.588817,35.7809619 136.655065,35.0610665 136.845761,34.3695652 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.20663,39.9130435 C139.884856,39.7228533 140.591829,39.6565746 141.293587,39.7173913 C141.995349,39.6551255 142.702583,39.7214287 143.380543,39.9130435 C142.003152,40.1913043 140.584022,40.1913043 139.20663,39.9130435 L139.20663,39.9130435 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.989239,45.6521739 C136.797883,44.9652491 136.731611,44.2495119 136.793587,43.5391304 C136.731611,42.828749 136.797883,42.1130118 136.989239,41.426087 C137.19661,42.1099516 137.26752,42.8279121 137.197935,43.5391304 C137.26752,44.2503487 137.19661,44.9683093 136.989239,45.6521739 L136.989239,45.6521739 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3675,43.1608696 C140.276195,43.1608696 139.884891,42.8869565 139.4675,42.4043478 C139.050109,41.9217391 138.802282,41.4521739 138.880543,41.373913 C138.958804,41.2956522 139.376195,41.6478261 139.780543,42.1434783 C140.184891,42.6391304 140.458804,43.0434783 140.3675,43.1608696 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.171848,36.7173913 C140.250109,36.7956522 139.976195,37.2130435 139.545761,37.6434783 C139.115326,38.073913 138.710978,38.3478261 138.632717,38.2695652 C138.554456,38.1913043 138.828369,37.7869565 139.258804,37.3565217 C139.689239,36.926087 140.093587,36.6391304 140.171848,36.7173913 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.384891,38.3608696 C135.384891,38.4521739 134.928369,38.2434783 134.524022,37.9043478 C134.119674,37.5652174 133.845761,37.226087 133.924022,37.1347826 C134.002282,37.0434783 134.380543,37.2521739 134.784891,37.5913043 C135.189239,37.9304348 135.463152,38.2695652 135.384891,38.3608696 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.202282,41.1913043 C135.280543,41.2695652 135.045761,41.673913 134.654456,42.1043478 C134.263152,42.5347826 133.884891,42.8086957 133.80663,42.7304348 C133.728369,42.6521739 133.963152,42.2478261 134.354456,41.8304348 C134.745761,41.4130435 135.124022,41.126087 135.202282,41.1913043 Z",
    id: "Path",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0066303,28.4217391 C20.331437,28.6276986 19.6222809,28.6986142 18.9196738,28.6304348 C18.2170666,28.6986142 17.5079105,28.6276986 16.8327172,28.4217391 C17.5109429,28.231549 18.2179162,28.1652703 18.9196738,28.226087 C19.6214313,28.1652703 20.3284046,28.231549 21.0066303,28.4217391 L21.0066303,28.4217391 Z",
    id: "Path",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.289239,22.7478261 C23.4870725,23.4335433 23.5534561,24.1504858 23.4848911,24.8608696 C23.5538562,25.5755633 23.4874799,26.2968523 23.289239,26.9869565 C23.0824841,26.2984951 23.011603,25.5763931 23.0805433,24.8608696 C23.0123092,24.1496525 23.083193,23.4319538 23.289239,22.7478261 Z",
    id: "Path",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5848911,28.2913043 C26.2598117,28.0839879 26.9692391,28.0130452 27.6718477,28.0826087 C28.3744548,28.0144293 29.0836109,28.0853449 29.7588042,28.2913043 C29.0805785,28.4814945 28.3736052,28.5477732 27.6718477,28.4869565 C26.9700857,28.5492224 26.2628517,28.4829192 25.5848911,28.2913043 Z",
    id: "Path",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3674998,33.9130435 C23.1614539,33.2289158 23.09057,32.5112171 23.1588042,31.8 C23.0898638,31.0844764 23.160745,30.3623745 23.3674998,29.673913 C23.5742547,30.3623745 23.6451358,31.0844764 23.5761955,31.8 C23.6444296,32.5112171 23.5735458,33.2289158 23.3674998,33.9130435 L23.3674998,33.9130435 Z",
    id: "Path",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7327172,31.526087 C26.6544564,31.6043478 26.2501085,31.2652174 25.8457607,30.7695652 C25.4414129,30.273913 25.1674998,29.8304348 25.2588042,29.7521739 C25.3501085,29.673913 25.7414129,30.026087 26.1588042,30.5086957 C26.5761955,30.9913043 26.8240216,31.4608696 26.7327172,31.526087 Z",
    id: "Path",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5501085,25.0956522 C26.6283694,25.173913 26.3414129,25.5782609 25.9240216,26.0086957 C25.5066303,26.4391304 25.089239,26.726087 24.9979346,26.6478261 C24.9066303,26.5695652 25.2066303,26.1521739 25.6240216,25.7217391 C26.0414129,25.2913043 26.4588042,25.0173913 26.5501085,25.0956522 Z",
    id: "Path",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.763152,26.7391304 C21.6848911,26.8173913 21.3066303,26.6217391 20.9022824,26.2826087 C20.4979346,25.9434783 20.2240216,25.6043478 20.289239,25.5130435 C20.3544564,25.4217391 20.7588042,25.6304348 21.163152,25.9695652 C21.5674998,26.3086957 21.8283694,26.6478261 21.763152,26.7391304 Z",
    id: "Path",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5674998,29.5695652 C21.6588042,29.6478261 21.4109781,30.0521739 21.0196738,30.4695652 C20.6283694,30.8869565 20.263152,31.173913 20.1718477,31.1086957 C20.0805433,31.0434783 20.3414129,30.626087 20.7196738,30.1956522 C21.0979346,29.7652174 21.489239,29.4913043 21.5674998,29.5695652 Z",
    id: "Path",
    fill: "#40A9FF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/Successful.d487b49b10579fa3d6f5b4ece6864766.svg";
export { ForwardRef as ReactComponent };